import { render, staticRenderFns } from "./changeList.vue?vue&type=template&id=3842a63e&scoped=true&"
import script from "./changeList.vue?vue&type=script&lang=js&"
export * from "./changeList.vue?vue&type=script&lang=js&"
import style0 from "./changeList.vue?vue&type=style&index=0&id=3842a63e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3842a63e",
  null
  
)

export default component.exports